var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.showEditGeo)?_c('li',{on:{"click":_vm.edit}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("edit")]),_vm._v(" Upravit zákres do mapy ")],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }